import { Button, IconButton, InputAdornment, TextField } from '@material-ui/core';
import { RemoveCircleRounded } from '@material-ui/icons';
import CancelIcon from '@material-ui/icons/Cancel';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSelectedRoom,
  greGlobalDefaultTabSelector,
} from '../../../../../layouts/configurations/configurationSlice';
import { selectedHotelSelector } from '../../../../../layouts/property/propertySlice';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../../../utils/formUtils';
import { saveOrUpdateRoomConfigs } from '../../../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';

const GuestRoomExperienceRoomTabRoomAreaContentThermostatEdit = (props) => {
  const { toggleDrawer, content, area, index, roomId } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const data = useSelector(greGlobalDefaultTabSelector);
  const [nameLanguages, setNameLanguages] = useState([]);
  const [deviceSpecificAttributes, setDeviceSpecificAttributes] = useState([]);
  const dispatch = useDispatch();
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    vendor: {
      value: '',
      fieldName: 'Vendor',
      errors: {},
      validations: ['required'],
    },
    name: {
      value: '',
      fieldName: 'Thermostat Name',
      errors: {},
      validations: ['required'],
    },
    id: {
      value: '',
      fieldName: 'Thermostat ID',
      errors: {},
      validations: ['required'],
    },
  });
  const [additionalInfo, setAdditionalInfo] = useState({
    index: null,
    field: '',
    value: '',
    code: '',
  });

  const [isAddingPair, setAddingPair] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [nameAliases, setNameAliases] = useState([]);

  useEffect(() => {
    if (data) {
      setNameLanguages(
        data.languages.map((language) => {
          return {
            languageCode: language.languageCode,
            languageName: language.languageName,
          };
        }),
      );
    }
  }, [data]);

  useEffect(() => {
    if (content) {
      const currFields = { ...formData };
      for (let field in currFields) {
        if (field === 'vendor') {
          currFields['vendor'].value = content['vendor'].name;
          setAttributes(content['vendor'].attributes);
          setDeviceSpecificAttributes(
            content['vendor'].controlSpecificAttributes.map((attr) => {
              return {
                field: attr.key,
                value: attr.value,
              };
            }),
          );
        } else {
          currFields[field].value = content[field];
        }
      }
      setFormData(currFields);

      if (content.nameAliases.length) {
        setNameAliases(content.nameAliases);
      }
    }
  }, [content]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        const payload = { ...content };

        for (let field in formData) {
          if (field === 'vendor') {
            let val = { ...payload[field] };
            val['name'] = formData[field].value;
            val['attributes'] = attributes;
            val['controlSpecificAttributes'] = deviceSpecificAttributes.map((attr) => {
              return {
                key: attr.field,
                value: attr.value,
              };
            });
            payload[field] = val;
          } else {
            payload[field] = formData[field].value;
          }
        }

        let tempNameAliases = [...nameAliases];
        payload['nameAliases'] = tempNameAliases;

        let tempAreaThermo = [...area.thermostats];

        tempAreaThermo.splice(index, 1, payload);
        let tempArea = { ...area };
        delete tempArea.name;
        tempArea['thermostats'] = tempAreaThermo;
        await saveOrUpdateRoomConfigs(selectedHotel, roomId, 'AREA', tempArea);
        notificationManager('success', 'Light details updated successfully');
        dispatch(fetchSelectedRoom(selectedHotel, roomId));
        toggleDrawer('', false, '');
      } catch (e) {
        if (e.errors) {
          notificationManager('danger', e.errors[0].message);
        } else {
          notificationManager('danger', 'Thermostat updation failed');
        }
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const handleInfoInputChange = (e, type) => {
    const inputValue = e.target.value;
    setAdditionalInfo((prev) => ({
      ...prev,
      [type]: inputValue,
    }));
  };

  const onInfoAdd = () => {
    if (isAddingPair) {
      if (additionalInfo.value && additionalInfo.field) {
        const infoArray = deviceSpecificAttributes?.length ? [...deviceSpecificAttributes] : [];
        const info = additionalInfo;
        if (info.code) {
          info.value = '+' + info.code + '_' + info.value.substr(info.code.length + 1);
        }
        info.index = infoArray.length + 1;
        delete info.code;
        infoArray.push(info);
        setDeviceSpecificAttributes(infoArray);
        setAdditionalInfo({ index: null, field: '', value: '' });
      }
    } else {
      setAddingPair(true);
    }
  };

  const onInfoDelete = (index) => {
    const attributeArray = [...deviceSpecificAttributes];
    attributeArray.splice(index, 1);
    setDeviceSpecificAttributes(attributeArray);
  };

  const onAttributeEdit = (attribute, value) => {
    let tempAttributes = [...attributes];
    setAttributes(
      tempAttributes.map((atr) => {
        return {
          key: atr.key,
          value: atr.key === attribute.key ? value.target.value : atr.value,
        };
      }),
    );
  };

  const onNameAliasesEdit = (alias, value) => {
    let tempNameAlliases = [...nameAliases];
    setNameAliases(
      tempNameAlliases.map((tempAlias) => {
        return {
          languageId: tempAlias.languageId,
          alias: tempAlias.languageId === alias.languageId ? value.target.value : tempAlias.alias,
        };
      }),
    );
  };

  return (
    <form onSubmit={handleSubmit} className='group-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>Edit Thermostat: {content.name}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4'>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.vendor}
                handleInputChange={(e) => {
                  setFormData({ vendor: e });
                }}
                disabled={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                hideAdornment={true}
                endAdornment={true}
                characterCount={true}
                maxLength={15}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.id}
                handleInputChange={(e) => {
                  setFormData({ id: e });
                }}
                hideAdornment={true}
                endAdornment={true}
                characterCount={true}
                maxLength={15}
              />
            </div>
            {nameAliases.map((alias, key) => (
              <div className='col-md-6 mb-3' key={key}>
                <TextField
                  className='col-md-12 pe-0'
                  id='language-name-field'
                  label={
                    'Thermostat Name (' +
                    nameLanguages.find((lang) => lang.languageCode === alias.languageId)
                      .languageName +
                    ')'
                  }
                  value={alias.alias}
                  onChange={(e) => onNameAliasesEdit(alias, e)}
                  required={true}
                  error={!alias.alias ? true : false}
                  helperText={
                    !alias.alias &&
                    `Light Name (${
                      nameLanguages.find((lang) => lang.languageCode === alias.languageId)
                        .languageName
                    }) required`
                  }
                  inputProps={{
                    maxLength: 15,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <span className='cusotm-text-field-end-adornment'>{`${
                          alias.alias.length
                        }/${15}`}</span>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            ))}
          </div>
          <div className='row'>
            {attributes.map((attribute, key) => (
              <div className='col-md-6 mb-3' key={key}>
                <TextField
                  className='col-md-12 pe-0'
                  id='language-name-field'
                  value={attribute.value}
                  label={attribute.key}
                  onChange={(e) => onAttributeEdit(attribute, e)}
                />
              </div>
            ))}
          </div>
          <div className='row'>
            <h4 className='tab-title mt-4'>Key Value Pair</h4>
            {isAddingPair && (
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <TextField
                    id='additional-info-field'
                    label='Enter Label Name'
                    className='col-md-12'
                    value={additionalInfo.field}
                    onChange={(e) => handleInfoInputChange(e, 'field', false)}
                    required={isAddingPair}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <TextField
                    id='additional-info-value'
                    label='Field Value'
                    className='col-md-12'
                    value={additionalInfo.value}
                    onChange={(e) => handleInfoInputChange(e, 'value', true)}
                    required={isAddingPair}
                  />
                </div>
              </div>
            )}
            <div className='row'>
              <div className='col-md-12 mb-3'>
                <Button
                  variant='outlined'
                  color={additionalInfo.value && additionalInfo.field ? 'primary' : 'secondary'}
                  disabled={isAddingPair && (!additionalInfo.value || !additionalInfo.field)}
                  onClick={onInfoAdd}
                >
                  Add
                </Button>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12 mb-3 drag-item'>
                {deviceSpecificAttributes.map((item, index) => (
                  <div className='row' key={index}>
                    <div className='col-md-6'>
                      <TextField
                        id='additional-info-field-edit'
                        className='col-md-6'
                        label={item.field}
                        value={item.value}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </div>
                    <div className='col-md-6 d-flex justify-content-end'>
                      <RemoveCircleRounded
                        onClick={(e) => onInfoDelete(index)}
                        className='additional-info-remove'
                        color='secondary'
                      ></RemoveCircleRounded>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button variant='contained' type='submit' color='primary' className='me-3' size='large'>
              Update
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default GuestRoomExperienceRoomTabRoomAreaContentThermostatEdit;
